/* eslint-disable */
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
/* eslint-enable */
import {
  configApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import {
  makeFieldSchemaFromZod,
  scaffolderPlugin,
} from '@backstage/plugin-scaffolder';
import { TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete'; // eslint-disable-line
import { Typography } from '@mui/material';
import axios, { HttpStatusCode } from 'axios'; // eslint-disable-line
import { useAsync } from 'react-use';
// zod/v3: makeFieldSchemaFromZod is typed against zod's v3 ZodType, whose generics
// differ from v4's. The root zod is v4.
import { z } from 'zod/v3'; // eslint-disable-line

export type GithubTeam = {
  name: string;
  id: number;
  node_id: string;
  slug: string;
  description: string;
  privacy: string;
  notification_setting: string;
  url: string;
  html_url: string;
  members_url: string;
  repositories_url: string;
  permission: string;
};

const GithubTeamsSchema = makeFieldSchemaFromZod(
  z.object({
    name: z.string(),
    slug: z.string(),
  }),
  z.object({}),
);

type GithubTeamsSchemaProps = typeof GithubTeamsSchema.type;
const GithubTeamsSchemaSchema = GithubTeamsSchema.schema;

const GithubTeams = ({ onChange, schema, required, formData }: GithubTeamsSchemaProps) => {
  const title = schema.title || name || 'GitHub Teams';
  const configApi = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const baseURL = `${configApi.getString(
    'backend.baseUrl',
  )}/api/proxy/api-github`;
  const { value, loading, error } = useAsync(async () => {
    const { token } = await identityApi.getCredentials();
    const response = await axios({
      url: `${baseURL}/orgs/TRANZACT/teams?per_page=100`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response && response.status !== HttpStatusCode.Ok) {
      throw new Error('Failed to fetch GitHub teams');
    }
    return await response.data as GithubTeam[];
  }, []);

  if (error) return <Typography color={'red'} variant='subtitle1'>error: {error.message}</Typography>;

  return (
    <FormControl>
      <Autocomplete
        loading={loading}
        options={value || []}
        value={formData ? value?.find(team => team.slug === formData.slug) || null : null}
        getOptionLabel={(team: GithubTeam) => team.name}
        renderInput={params => (
          <TextField
            {...params}
            label={title}
            variant="outlined"
            required={required}
          />
        )}
        onChange={(_event, team: GithubTeam | null) => {
          if (team) {
            onChange({
              name: team.name,
              slug: team.slug,
            });
            localStorage.setItem('githubTeamsField:selectedTeam', JSON.stringify({
              name: team.name,
              slug: team.slug,
            }));
          } else {
            onChange(undefined);
          }
        }}
      />
    </FormControl>
  );
};

export const GithubTeamsExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubTeams',
    component: GithubTeams,
    schema: GithubTeamsSchemaSchema,
  }),
);
